import React from 'react';

export default function Guidelines(props) {
    const {setGuidelinesAcknowledged} = props;

      const suggestionAreaStyle = {
    backgroundColor: '#f0f9ff', // Light blue background
    border: '1px solid #93c5fd', // Blue border
    borderRadius: '0.75rem',
    padding: '1rem',
    marginTop: '1.5rem',
    fontSize: '0.95rem',
    color: '#1e40af', // Darker blue text
    lineHeight: '1.6',
  };

  const suggestionHeaderStyle = {
    fontWeight: '700',
    marginBottom: '0.5rem',
    color: '#1e3a8a',
  };

  const suggestionListStyle = { // Re-added for potential use if LLM returns bulleted content directly
    listStyleType: 'disc',
    marginLeft: '1.5rem',
  };

  const geminiErrorStyle = {
    backgroundColor: '#ffeaea', // Light red background
    border: '1px solid #ef4444', // Red border
    borderRadius: '0.5rem', // Rounded corners
    padding: '0.75rem',
    marginTop: '1rem',
    fontSize: '0.875rem',
    color: '#ef4444', // text-red-500
    textAlign: 'center',
  };

  // --- New Styles for Guidelines Page ---

  const guidelinesContainerStyle = {
    backgroundColor: '#ffffff',
    borderRadius: '1.5rem',
    boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
    padding: '2.5rem',
    width: '100%',
    maxWidth: '800px',
    border: '1px solid #e2e8f0',
    position: 'relative',
    paddingTop: '3rem', // Adjust padding for guidelines page
    textAlign: 'center', // Center content for guidelines
  };

  const guidelinesHeaderStyle = {
    fontSize: '2rem',
    fontWeight: '800',
    color: '#1a202c',
    marginBottom: '1.5rem',
    textShadow: '1px 1px 3px rgba(0,0,0,0.05)',
  };

  const guidelinesIntroTextStyle = { // New style for intro text
    fontSize: '1.1rem',
    color: '#4a5568',
    lineHeight: '1.7',
    marginBottom: '1.5rem',
    textAlign: 'left',
  };

  const guidelinesSubHeaderStyle = {
    fontSize: '1.3rem',
    fontWeight: '700',
    color: '#2d3748',
    marginTop: '1.5rem',
    marginBottom: '1rem',
    textAlign: 'left',
    borderBottom: '1px solid #e0e7ff',
    paddingBottom: '0.5rem',
  };

  const guidelinesListOverallStyle = {
    paddingLeft: '0', // Remove default padding
    listStyleType: 'none', // Remove default list style for custom formatting
    marginBottom: '2rem',
    textAlign: 'left',
    color: '#4a5568',
  };

  const guidelinesListItemContainerStyle = { // Style for each major guideline point (e.g., S.NO, Responsibility, etc.)
    marginBottom: '1rem',
    paddingLeft: '0', // No default padding
    display: 'flex',
    alignItems: 'flex-start',
  };

  const guidelinesListItemNumberStyle = {
    fontWeight: '700',
    color: '#6366f1', // Indigo color for numbers
    fontSize: '1.1rem',
    minWidth: '1.8rem', // Fixed width for alignment
    textAlign: 'right',
    marginRight: '0.5rem',
  };

  const guidelinesItemContentStyle = {
    flexGrow: 1,
    lineHeight: '1.6',
  };

  // NEW: Style for sub-list items within the guidelines
  const guidelinesNestedListItemStyle = {
    marginBottom: '0.8rem', // Consistent spacing for nested items
  };



  const acknowledgeButtonStyle = {
    backgroundColor: '#6366f1', // bg-indigo-500
    color: '#ffffff',
    fontWeight: '700',
    padding: '0.9rem 2.5rem', // px-10 py-3.5
    borderRadius: '0.75rem',
    border: 'none',
    cursor: 'pointer',
    fontSize: '1.125rem',
    boxShadow: '0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -2px rgba(0,0,0,0.05)',
    transition: 'all 0.2s ease-in-out',
    display: 'inline-block', // Keep it inline-block for centering
    // Hover styles
    ':hover': {
      backgroundColor: '#4f46e5',
      boxShadow: '0 15px 25px -5px rgba(0,0,0,0.15), 0 8px 10px -5px rgba(0,0,0,0.08)',
      transform: 'translateY(-2px)',
    },
  };

  const formPageContainerStyle = {
    fontFamily: '"Inter", sans-serif',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center', // Center content vertically
    backgroundColor: '#f8fafc', // bg-gray-50
    //padding: '2rem 1rem', // p-8 md:p-10
  };


  return (
    <div>
        <div style={formPageContainerStyle}>
        <div style={guidelinesContainerStyle}>
          <h2 style={guidelinesHeaderStyle}>Research Application Guidelines</h2>
          <p style={guidelinesIntroTextStyle}>
            We welcome a Researcher who wants to do a project, internship, MPhil and PhD to fill the application and do the registration. Before proceeding, please go through the following rules and regulations for research in the Jesuit Madurai Province Archives:
          </p>

          <ul style={guidelinesListOverallStyle}>
            <li style={guidelinesListItemContainerStyle}>
              <span style={guidelinesListItemNumberStyle}>1.</span>
              <div style={guidelinesItemContentStyle}>
                Research in the Jesuit Madurai Province Archives is on <strong>prior appointment only.</strong>
              </div>
            </li>

            <li style={guidelinesListItemContainerStyle}>
              <span style={guidelinesListItemNumberStyle}>2.</span>
              <div style={guidelinesItemContentStyle}>
                Research in the Archives is allowed only for <strong>bona fide researchers</strong>, with the approval and guidance of the Director of archives. A letter of identification or ID is mandatory.
              </div>
            </li>

            <li style={guidelinesListItemContainerStyle}>
              <span style={guidelinesListItemNumberStyle}>3.</span>
              <div style={guidelinesItemContentStyle}>
                <strong style={{ display: 'block', marginBottom: '0.5rem' }}>Responsibility of a Researcher</strong>
                <ol style={{ marginTop: '0.25rem', paddingLeft: '1.4rem', color: '#4a5568' }}>
                  <li style={guidelinesNestedListItemStyle}>3.1 Researcher is requested to follow the rules and regulations of the archives carefully and handle the archives resources very responsibly as they are old and brittle. <br/> It is a religious Archives and hence a researcher is asked to understand the context and content historically. Your research should uphold the values of building our nation and our people. Your constructive contribution through reasearch should bring harmony and development.</li>
                  <li style={guidelinesNestedListItemStyle}>3.2 Research scholars shall give a brief description to the Director of their research needs from the Archives.</li>
                  <li style={guidelinesNestedListItemStyle}>3.3 Researcher may have access to books and scanned copies of Manuscripts, Annual Letters, Diaries and Photographs.</li>
                  <li style={guidelinesNestedListItemStyle}>3.4 You may take writing materials or laptop with you into the researcher’s room.</li>
                  <li style={guidelinesNestedListItemStyle}>3.5 Silence shall be maintained in the researcher’s room.</li>
                  <li style={guidelinesNestedListItemStyle}>3.6 Eating, drinking, use of cell phone or camera and smoking in the premises of Archives and taking bags and briefcases into archives are not permitted.</li>
                  <li style={guidelinesNestedListItemStyle}>3.7 Materials collected from our Archives are for the said purpose only.</li>
                  <li style={guidelinesNestedListItemStyle}>3.8 Permission must be obtained to publish any records from the Jesuit Madurai Province Archives.</li>
                  <li style={guidelinesNestedListItemStyle}>3.9 We request you to give a copy of your thesis, project or publication to our archives, as it will be a great help for other researchers.</li>
                </ol>
              </div>
            </li>

            <li style={guidelinesListItemContainerStyle}>
              <span style={guidelinesListItemNumberStyle}>4.</span>
              <div style={guidelinesItemContentStyle}>
                <strong style={{ display: 'block', marginBottom: '0.5rem' }}>Accessibility: Dates and Timings</strong>
                Archives welcomes you.<br />
                Morning: <strong>09:00am – 12:45 pm</strong><br />
                Afternoon: <strong>02:00pm –05:00 pm</strong><br />
                Archives is Closed on Sundays and National Holidays
              </div>
            </li>

            <li style={guidelinesListItemContainerStyle}>
              <span style={guidelinesListItemNumberStyle}>5.</span>
              <div style={guidelinesItemContentStyle}>
                <strong style={{ display: 'block', marginBottom: '0.5rem' }}>Accomodation</strong>
                If you need boarding and lodging in Sacred Heart College for your research period, contact the Director of Archives (9443377841).
              </div>
            </li>

            <li style={guidelinesListItemContainerStyle}>
              <span style={guidelinesListItemNumberStyle}>6.</span>
              <div style={guidelinesItemContentStyle}>
                <strong style={{ display: 'block', marginBottom: '0.5rem' }}>Registration</strong>
                Registration fee is <strong>Rs. 1000/- (One Thousand only).</strong><br />
                Permitted pages could be photocopied on payment.
              </div>
            </li>
          </ul>

          <button
            onClick={() => {window.scrollTo(0,0); setGuidelinesAcknowledged(true)}}
            style={acknowledgeButtonStyle}
            onMouseEnter={(e) => Object.assign(e.currentTarget.style, acknowledgeButtonStyle[':hover'])}
            onMouseLeave={(e) => Object.assign(e.currentTarget.style, { backgroundColor: acknowledgeButtonStyle.backgroundColor, boxShadow: acknowledgeButtonStyle.boxShadow, transform: 'none' })}
          >
            I Acknowledge
          </button>
        </div>
      </div>
    </div>
  )
}
